import axios from 'axios';
import { handleRateLimitError } from '../utils/rateLimitHandler';

// Use relative URL '/api' in production (when REACT_APP_API_URL is not set)
// This allows the client to connect to the API on the same origin
const API_BASE_URL = process.env.REACT_APP_API_URL || '/api';

// Single authenticated client. All authenticated service modules should import
// this default export instead of creating their own axios instances.
const api = axios.create({
  baseURL: API_BASE_URL,
});

// Add token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle authentication errors and rate limiting.
// We only log out on 401 (missing/expired/invalid token) or an explicit
// invalid-token 403. Legitimate 403 permission responses (disabled account,
// pending verification, insufficient permissions) must NOT destroy the session.
function isInvalidTokenResponse(error) {
  return error.response?.status === 401 ||
    (error.response?.status === 403 && error.response?.data?.error === 'Invalid token');
}

// Handle authentication errors and rate limiting
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (isInvalidTokenResponse(error)) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }

    // Handle rate limiting errors (429)
    if (error.response?.status === 429) {
      return Promise.reject(handleRateLimitError(error));
    }

    return Promise.reject(error);
  }
);

export const login = (email, password) => {
  return api.post('/auth/login', { email, password });
};

export const getCurrentUser = () => {
  return api.get('/auth/me');
};

export default api;